import {NumberOfResultsDefaultBox} from "./number-of-results.default.box";

export const NumberOfResultsBox = NumberOfResultsDefaultBox;